<div class="message-card orange mb-3">
    <mwp-text-translate text="Following benefits are automatically enrolled by the system." jsonKey="autoEnrollNotice" />
</div>
<div class="content-container table-comp mb-3">
    <div class="title">
        <mwp-text-translate text="Auto Enrolled Benefits" jsonKey="autoEnrolledBenefits" />
    </div>
    <div class="content">
        <mwp-table [tableColumns]="autoTableColumns" [dataSource]="autoMatTableData" />
    </div>
    <div class="footer">
        <div class="message-card blue-fill d-inline-flex justify-content-between w-100">
            <mwp-text-translate text="Total Auto Enrollment Deduction" jsonKey="autoEnrollTotalText" />
            <span>{{ wizardCoverageSummary.totalDeduction }}</span>
        </div>
    </div>
</div>
<div>
    <mwp-benefit-enrollment-wizard-control [isCheckout]="true" (emitComplete)="complete()" />
</div>